import { DataType } from "../../../../form/typings";
import { styleControlOptions } from "../../../../form/component-schema";
import i18n from "../../../i18n";
export default {
    $id: "sequenceNo",
    type: DataType.Object,
    $ref: styleControlOptions.$id,
    properties: {
        widgetType: {
            type: DataType.String,
            title: i18n.t('dataitem.ControlType').toString(),
        },
        dataItemType: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemType').toString(),
        },
        prefix: {
            type: DataType.String,
            title: i18n.t('dataitem.SerialCode').toString(),
        },
        maxLength: {
            type: DataType.String,
            title: i18n.t('dataitem.MaxLength').toString(),
            default: "6",
        },
        resetDate: {
            type: DataType.String,
            title: i18n.t('dataitem.ResetTime').toString(),
            default: "YEAR",
        },
        delimiter: {
            type: DataType.String,
            title: i18n.t('dataitem.Connector').toString(),
            default: "mark1",
        },
        labelVisible: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.LabelVisible').toString(),
            default: true,
        },
    }
};
